var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconeTemperatura(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 54,
    viewBox: "0 0 36 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.43975 47.7369C2.43975 44.7287 4.1607 42.1248 6.66867 40.8491L6.68443 16.9045H4.22893V39.3791C1.72095 40.6601 0 43.2588 0 46.2722C0 49.5953 2.09872 52.425 5.04218 53.517C3.44715 52.0995 2.43453 50.0363 2.43453 47.7369H2.43975Z",
    fill: "#C0E3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69501 0.167969C5.27313 0.614206 4.229 1.92668 4.229 3.49639V16.8992H6.68451L6.69501 0.167969Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.68438 16.8994L6.66862 40.844C4.16065 42.1249 2.4397 44.7236 2.4397 47.7318C2.4397 50.0312 3.45235 52.0944 5.04738 53.5118C5.88687 53.8216 6.78406 54.0001 7.72849 54.0001C11.9941 54.0001 15.457 50.5404 15.457 46.2671C15.457 43.2536 13.7361 40.655 11.2281 39.374V16.8994H6.68438Z",
    fill: "#64BDFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72844 0C7.36641 0 7.02538 0.0682518 6.69483 0.167999L6.68433 16.8993H11.228V3.49642C11.228 1.56447 9.65926 0 7.72844 0Z",
    fill: "#BEC4CE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70508 21.0921H11.1627V19.6904H7.70508V21.0921Z",
    fill: "#DEF0FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70508 25.0716H11.1627V23.6699H7.70508V25.0716Z",
    fill: "#DEF0FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70508 29.0509H11.1627V27.6492H7.70508V29.0509Z",
    fill: "#DEF0FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70508 33.0356H11.1627V31.6287H7.70508V33.0356Z",
    fill: "#DEF0FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70508 37.0096H11.1627V35.6079H7.70508V37.0096Z",
    fill: "#DEF0FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5376 37.5211C30.4488 37.5211 31.229 37.3702 31.8846 37.0619C32.5402 36.7602 33.2286 36.2682 33.9432 35.5991L35.6411 37.344C33.9825 39.1807 31.9764 40.0991 29.6162 40.0991C27.2561 40.0991 25.2959 39.3381 23.7355 37.8163C22.1818 36.2944 21.4016 34.3724 21.4016 32.0437C21.4016 29.715 22.1949 27.7864 23.7814 26.2252C25.368 24.6771 27.3675 23.9031 29.7932 23.9031C32.2124 23.9031 34.2382 24.7952 35.8641 26.586L34.1857 28.4228C33.4449 27.7077 32.7369 27.2092 32.0747 26.9205C31.4126 26.645 30.6324 26.4942 29.7408 26.4942C28.1608 26.4942 26.8365 27.0058 25.7613 28.0291C24.6862 29.0525 24.1486 30.3513 24.1486 31.9453C24.1486 33.5328 24.6796 34.8579 25.7417 35.9205C26.8103 36.9898 28.0756 37.5211 29.531 37.5211H29.5376Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9009 25.5034C17.0158 25.5034 16.2947 24.7884 16.2947 23.9028C16.2947 23.0173 17.0158 22.2957 17.9009 22.2957C18.786 22.2957 19.5071 23.0173 19.5071 23.9028C19.5071 24.7884 18.7925 25.5034 17.9009 25.5034ZM17.9009 20.3999C15.9669 20.3999 14.4 21.9677 14.4 23.9028C14.4 25.8314 15.9669 27.3991 17.9009 27.3991C19.8349 27.3991 21.4018 25.8314 21.4018 23.9028C21.4018 21.9677 19.8349 20.3999 17.9009 20.3999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeTemperatura);
export default __webpack_public_path__ + "static/media/iconeTemperatura.ae66fd88348b966f90e1a42ff61c8a94.svg";
export { ForwardRef as ReactComponent };